var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{staticClass:"mt-6",attrs:{"title":"Title Company","no_border":true}},[_c('input-text',{staticClass:"w-full",attrs:{"name":"title_company","value":_vm.closing.title_company,"read_only":_vm.read_only}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }